import React, {createRef, useEffect, useState} from 'react'
import BlackDiv from './ui/BlackDiv'
import H1 from './ui/H1'
import HalfDiv from './ui/HalfDiv'

const facebookRef = createRef(null)

export default React.memo(()=>{
   const [loaded, setLoaded] = useState(true)
   useEffect(()=>{
      
   },[])
    return(
        <div>
            {loaded && <React.Fragment>
            <br/>
            <br/>
            <br/>
            <br/>
            <H1>Events</H1>
        <div ref = {facebookRef} style={{padding:'1rem',boxSizing:'border-box'}}>

        <br/>
        <HalfDiv>
         <div 
         id="fb-page"
         className="fb-page" 
         data-width="275"
         data-href="https://www.facebook.com/exaltedchristianband/events" 
         data-tabs="events" 
         data-small-header="false" 
         data-adapt-container-width="true" 
         data-hide-cover="false" 
         data-lazy="true"
         data-show-facepile="true">
             <blockquote cite="https://www.facebook.com/exaltedchristianband/events" 
             class="fb-xfbml-parse-ignore">
                 <a href="https://www.facebook.com/exaltedchristianband/events">If nothing appears, try refreshing the page.</a>
                 </blockquote>
        </div>
         
         <div>
             <br/>
             <br/>
             <br/>
            <h2 style={{textAlign:'center', display:'flex',alignItems:'center',justifyContent:'center'}}> &nbsp;&nbsp;<span>OUR EVENTS</span></h2>
                <p style={{padding:'1rem'}}>Exalted Christian Band is active in playing for worship services, churches, and events in Southwest Virginia. Find our next event here!
            
                </p>
         </div>
         
        </HalfDiv>

        </div>
        </React.Fragment>}

       
        
        </div>
    )
})